import React, { useMemo } from "react";
import {
  ClipboardList,
  Book,
  Wrench,
  HelpCircle,
  Shield,
  FileEdit,
  Activity,
  FolderOpen,
} from "lucide-react";
import { Tabs } from "@shared/ui/tabs";

// Import individual tab components
import TasksTab from "./tabs/TaskTab";
import ReadingsTab from "./tabs/ReadingTab";
import MaterialsTab from "./tabs/MaterialTab";
import HelpTab from "./tabs/HelpTab";
import SafetyTab from "./tabs/SafetyTab";
import NotesTab from "./tabs/NotesTab";
import ActivityTab from "./tabs/ActivityTab";
import DocumentsTab from "./tabs/DocumentTab";

interface SopTabsContainerProps {
  currentTab?: string; // Made optional since URL will control this
  onTabChange?: (tab: string) => void; // Made optional since URL will control this
  sopDetails: any;
}

const SopTabsContainer: React.FC<SopTabsContainerProps> = ({
  currentTab,
  onTabChange,
  sopDetails,
}) => {
  // Create tab components configuration
  const tabComponents = useMemo(
    () => ({
      tasks: {
        label: "Tasks",
        icon: <ClipboardList className="w-4 h-4" />,
        component: <TasksTab sopDetails={sopDetails} />,
        shortLabel: "Tasks", // For mobile responsiveness
      },
      readings: {
        label: "Readings",
        icon: <Book className="w-4 h-4" />,
        component: <ReadingsTab sopDetails={sopDetails} />,
        shortLabel: "Read",
      },
      materials: {
        label: "Materials",
        icon: <Wrench className="w-4 h-4" />,
        component: <MaterialsTab sopDetails={sopDetails} />,
        shortLabel: "Mat",
      },
      help: {
        label: "Help",
        icon: <HelpCircle className="w-4 h-4" />,
        component: <HelpTab sopDetails={sopDetails} />,
        shortLabel: "Help",
      },
      safety: {
        label: "Safety",
        icon: <Shield className="w-4 h-4" />,
        component: <SafetyTab sopDetails={sopDetails} />,
        shortLabel: "Safe",
      },
      notes: {
        label: "Notes",
        icon: <FileEdit className="w-4 h-4" />,
        component: <NotesTab sopDetails={sopDetails} />,
        shortLabel: "Note",
      },
      activity: {
        label: "Activity",
        icon: <Activity className="w-4 h-4" />,
        component: <ActivityTab sopDetails={sopDetails} />,
        shortLabel: "Act",
      },
    }),
    [sopDetails]
  );

  return (
    <Tabs
      className="w-full"
      defaultValue={currentTab || "tasks"}
      urlMapping={{
        tasks: "tasks",
        readings: "readings",
        materials: "materials",
        help: "help",
        safety: "safety",
        notes: "notes",
        activity: "activity",
        documents: "documents",
      }}
      tabComponents={tabComponents}
      tabsListClassName="grid w-full grid-cols-4 md:grid-cols-8"
      idPrefix="sop"
    />
  );
};

export default SopTabsContainer;
